// extracted by css-extract-rspack-plugin
export default {"flash":"SearchTypeError-module__flash__CZorO"};